import {
	downloadData,
	getUrl,
	list,
	remove,
	uploadData,
} from 'aws-amplify/storage'

type LegacyStorageOptions = {
	level?: 'guest' | 'public' | 'protected' | 'private'
	identityId?: string | null
	targetIdentityId?: string | null
	download?: boolean
	expires?: number
	contentType?: string
	progressCallback?: (progress: unknown) => void
	onProgress?: (progress: unknown) => void
	[key: string]: any
}

const mapAccessLevel = (level?: LegacyStorageOptions['level']) => {
	return level === 'public' ? 'guest' : level
}

const mapOptions = (options: LegacyStorageOptions = {}) => {
	const {
		level,
		identityId,
		targetIdentityId,
		download,
		expires,
		progressCallback,
		...rest
	} = options

	return {
		...rest,
		accessLevel: mapAccessLevel(level),
		targetIdentityId: targetIdentityId ?? identityId ?? undefined,
		expiresIn: expires,
		onProgress: options.onProgress ?? progressCallback,
	}
}

export const Storage = {
	get: async (key: string, options: LegacyStorageOptions = {}) => {
		const mappedOptions = mapOptions(options)
		if (options.download) {
			const result = await downloadData({
				key,
				options: mappedOptions,
			}).result
			return {
				...result,
				Body: result.body,
			}
		}

		const result = await getUrl({
			key,
			options: mappedOptions,
		})
		return result.url.toString()
	},
	put: async (
		key: string,
		data: Blob | File | ArrayBuffer | string,
		options: LegacyStorageOptions = {}
	) => {
		return uploadData({
			key,
			data,
			options: mapOptions(options),
		}).result
	},
	remove: async (key: string, options: LegacyStorageOptions = {}) => {
		return remove({
			key,
			options: mapOptions(options),
		})
	},
	list: async (path: string, options: LegacyStorageOptions = {}) => {
		return list({
			prefix: path,
			options: mapOptions(options),
		})
	},
}
